var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScissors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.719 1.29996L12.674 1L4.80749 15.087C4.57127 15.5145 4.03508 15.6682 3.60389 15.4432C3.59639 15.4395 3.59264 15.4357 3.58514 15.432C2.75274 15.0045 1.71787 15.3082 1.24543 16.1144C0.739239 16.9768 1.04295 18.0829 1.90909 18.5666C2.76774 19.0465 3.84761 18.7391 4.32755 17.8804L6.41979 14.1309C6.53978 13.9172 6.80599 13.8422 7.01972 13.9622C7.26344 14.0971 7.56715 14.0109 7.70213 13.7672L11.7666 6.48557C12.6515 4.91077 12.9852 3.08474 12.719 1.29996ZM3.46515 17.3967C3.25143 17.7754 2.77149 17.9142 2.39279 17.7004C2.01408 17.4867 1.87535 17.0068 2.08907 16.6281C2.3028 16.2494 2.78274 16.1106 3.16144 16.3244C3.54389 16.5381 3.67888 17.018 3.46515 17.3967ZM8.42579 11.0563C8.17832 11.0563 7.9796 10.8575 7.9796 10.6101C7.9796 10.3626 8.17832 10.1639 8.42579 10.1639C8.67326 10.1639 8.87199 10.3626 8.87199 10.6101C8.87199 10.8575 8.66951 11.0563 8.42579 11.0563Z",
    stroke: "#31222A",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3704 16.3516C14.913 15.5342 13.8856 15.2117 13.0457 15.6204C13.0382 15.6242 13.0345 15.6279 13.027 15.6317C12.592 15.8491 12.0596 15.6804 11.8309 15.253L9.81361 11.3984L8.71875 13.3594L8.95872 13.8694C9.08995 14.1131 9.39367 14.2068 9.63739 14.0794C9.85111 13.9669 10.1211 14.0456 10.2336 14.2631L12.2471 18.0576C12.7083 18.9238 13.7844 19.2537 14.6505 18.7925C15.5317 18.3238 15.8579 17.2252 15.3704 16.3516ZM14.1893 17.9189C13.8031 18.1214 13.3269 17.9751 13.1245 17.5927C12.922 17.2065 13.0682 16.7303 13.4507 16.5278C13.8369 16.3253 14.3131 16.4716 14.5155 16.854C14.718 17.2365 14.5718 17.7127 14.1893 17.9189Z",
    stroke: "#31222A",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82782 9.9689L7.92268 8.00414L4.26688 1L4.21439 1.29996C3.91068 3.08099 4.20314 4.91077 5.05053 6.50432L6.82782 9.9689Z",
    stroke: "#31222A",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/scissors.6acc02c8.svg";
export { ForwardRef as ReactComponent };